class GiftNoteDrawer extends HTMLElement {
  constructor() {
    super();
    this.overlay = this.querySelector('.gift-note-drawer__overlay');
    this.panel = this.querySelector('.gift-note-drawer__panel');
    this.loading = this.querySelector('.gift-note-drawer__loading');
    this.textarea = this.querySelector('.gift-note-drawer__textarea');
    this.fromInput = this.querySelector('.gift-note-drawer__from-input');
    this.emailInput = this.querySelector('.gift-note-drawer__email-input');
    this.saveBtn = this.querySelector('.gift-note-drawer__save');
    this.closeBtn = this.querySelector('.gift-note-drawer__close');
    this.backBtn = this.querySelector('.gift-note-drawer__back');
    this.miniCart = document.querySelector('mini-cart');
    this.miniCartInner = document.querySelector('.mini-cart__inner');

    this.bindEvents();
  }

  bindEvents() {
    this.overlay.addEventListener('click', () => this.close());
    this.closeBtn.addEventListener('click', () => this.close());
    if (this.backBtn) this.backBtn.addEventListener('click', () => this.close());
    this.saveBtn.addEventListener('click', () => this.save());

    // Held as instance refs so disconnectedCallback can detach them. The mini-cart
    // re-renders its whole section on every cart change, replacing this element;
    // without cleanup each render would leave another dead drawer listening for
    // the toggle click.
    this.onDocumentClick = (e) => {
      if (e.target.closest('[data-gift-note-drawer-toggle]')) {
        this.open();
      }
    };
    this.onMenuDrawerClose = () => this.resetInstant();

    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('menudrawer:close', this.onMenuDrawerClose);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('menudrawer:close', this.onMenuDrawerClose);
  }

  open() {
    const donationDrawer = document.querySelector('donation-drawer');
    if (donationDrawer && donationDrawer.classList.contains('is-open')) donationDrawer.close();
    this.classList.add('is-open');
    if (this.miniCartInner) this.miniCartInner.classList.add('is-pushed');
  }

  close() {
    this.classList.remove('is-open');
    if (this.miniCartInner) this.miniCartInner.classList.remove('is-pushed');
  }

  resetInstant() {
    this.style.transition = 'none';
    if (this.panel) this.panel.style.transition = 'none';
    this.classList.remove('is-open');
    if (this.miniCartInner) {
      this.miniCartInner.style.transition = 'none';
      this.miniCartInner.classList.remove('is-pushed');
    }
    requestAnimationFrame(() => {
      this.style.removeProperty('transition');
      if (this.panel) this.panel.style.removeProperty('transition');
      if (this.miniCartInner) this.miniCartInner.style.removeProperty('transition');
    });
  }

  showLoading() {
    this.loading.classList.remove('hidden');
  }

  hideLoading() {
    this.loading.classList.add('hidden');
  }

  save() {
    const note = this.textarea.value.trim();
    const from = this.fromInput ? this.fromInput.value.trim() : '';
    const email = this.emailInput ? this.emailInput.value.trim() : '';
    this.showLoading();

    // Carry the gift details onto the order as cart attributes, which Shopify
    // surfaces under the order's Additional details. All three gift fields —
    // including the message — go here so they appear together; the message is
    // NOT written to the order note, which is the separate general cart-note
    // feature (settings.show_cart_note). Keys are human-readable so they're
    // unambiguous in the admin ("email" alone reads like the buyer's email).
    //
    // "If populated": each field is sent as its current value — a filled field is
    // captured, and an emptied one clears the previously-saved value, since
    // Shopify drops attributes whose value is an empty string.
    const attributes = {
      'Gift note': note,
      'Gift recipient email': email,
      'Gift from': from,
    };

    const sections = this.getSectionsToRender().map((s) => s.section);
    const body = JSON.stringify({
      attributes: attributes,
      sections: sections,
      sections_url: cartSectionsUrl()
    });

    fetch(`${theme.routes.cart_update_url}`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then((response) => {
        this.hideLoading();
        this.close();
        setTimeout(() => {
          if (this.miniCart) {
            this.miniCart.renderContents(response);
          }
        }, cssDurationMs('--duration-long'));
      })
      .catch((e) => {
        console.error(e);
        this.hideLoading();
      });
  }

  getSectionsToRender() {
    return [
      { id: 'mini-cart', section: 'mini-cart', selector: '.shopify-section' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
      { id: 'mobile-cart-icon-bubble', section: 'mobile-cart-icon-bubble', selector: '.shopify-section' }
    ];
  }
}

customElements.define('gift-note-drawer', GiftNoteDrawer);
